export default "__VITE_ASSET__BKe9rZ1I__"